__turbopack_context__.v({
  "container": "VisionSection-module__qIzo4G__container",
  "fallbackImage": "VisionSection-module__qIzo4G__fallbackImage",
  "mediaContainer": "VisionSection-module__qIzo4G__mediaContainer",
  "root": "VisionSection-module__qIzo4G__root" + " " + __turbopack_context__.i(46473)["sectionPadding"],
  "unicornEmbed": "VisionSection-module__qIzo4G__unicornEmbed",
});
